"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = exports.TEST_ID_PROFILE_AVATAR = exports.TEST_ID_PROFILE = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var Image_1 = require("../../atoms/Image/Image");
var down_arrow_svg_1 = __importDefault(require("../../styles/Icons/assets/down-arrow.svg"));
var jangle_1 = require("../../styles/Jangle/jangle");
var crown_png_1 = __importDefault(require("./crown.png"));
var ProfileDropdownMenu_1 = require("./ProfileDropdownMenu");
var nameColours = [__1.theme.colors.brandGreen, __1.theme.colors.brandOrange, __1.theme.colors.brandPink, __1.theme.colors.brandTurquoise];
exports.TEST_ID_PROFILE = "profile";
exports.TEST_ID_PROFILE_AVATAR = "profileAvatar";
var Profile = function (_a) {
    var displayName = _a.displayName, csx = _a.csx, profileAvatarCsx = _a.profileAvatarCsx, toggleMenu = _a.toggleMenu, _b = _a.isMenuOpen, isMenuOpen = _b === void 0 ? false : _b, _c = _a.menuItems, menuItems = _c === void 0 ? [] : _c;
    var colourIndex = displayName.charCodeAt(0) % nameColours.length;
    var firstLetterOfDisplayName = displayName[0];
    // Mod easter egg
    var getBackgroundColour = function () { return displayName.startsWith("Mod ") ? __1.theme.colors.grey900 : nameColours[colourIndex]; };
    var getProfileIcon = function () { return displayName.startsWith("Mod ") ? react_1.default.createElement("img", { src: crown_png_1.default, alt: "JMod Crown", height: "28px" }) : firstLetterOfDisplayName; };
    var hasDropdown = typeof toggleMenu === "function" && menuItems.length > 0;
    return (react_1.default.createElement(theme_ui_1.Flex, { sx: __assign({ alignItems: "center" }, csx), "data-testid": exports.TEST_ID_PROFILE },
        react_1.default.createElement(theme_ui_1.Flex, { onClick: toggleMenu, sx: { cursor: hasDropdown ? "pointer" : "default" } },
            react_1.default.createElement(theme_ui_1.Text, { sx: {
                    variant: "text.h5",
                    ml: [__1.theme.space[2], 0, __1.theme.space[2], 0],
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }, as: "span" }, displayName),
            hasDropdown && react_1.default.createElement(Image_1.Image, { src: down_arrow_svg_1.default, alt: "Dropdown arrow", "aria-label": "Dropdown arrow", csx: { marginLeft: __1.theme.space[2] + "px" } })),
        hasDropdown && react_1.default.createElement(ProfileDropdownMenu_1.ProfileDropdownMenu, { isOpen: isMenuOpen, menuItems: menuItems }),
        react_1.default.createElement(theme_ui_1.Flex, { "data-testid": "profileAvatar", "data-testcolor": getBackgroundColour(), sx: __assign({ alignItems: "center", color: __1.theme.colors.white, fontFamily: __1.theme.fonts.body, fontSize: "26px", height: __1.theme.space[7] + __1.theme.space[1], justifyContent: "center", ml: 4, position: "relative", width: 7, "::before": {
                    background: getBackgroundColour(),
                    content: "''",
                    height: "100%",
                    left: 0,
                    position: "absolute",
                    top: 0,
                    transform: "skew(-" + jangle_1.JANGLE_DEGREES + "deg)",
                    width: "100%",
                    zIndex: -1
                } }, profileAvatarCsx) }, getProfileIcon())));
};
exports.Profile = Profile;
